import {Config} from 'angular-ecmascript/module-helpers';
import Moment from "moment/moment";

export default class LocaleConfig extends Config {
    static $inject = ['$translateProvider'];

    configure() {
        this.$translateProvider.useStaticFilesLoader({
            prefix: 'i18n/locale-',
            suffix: '.json'
        });

        this.$translateProvider.preferredLanguage('de');
        this.$translateProvider.fallbackLanguage('en');
        this.$translateProvider.useSanitizeValueStrategy('escape');
        this.$translateProvider.usePostCompiling(false);

        // Modify the toJSON function to return a ISO8601 string that reflects the moment's utcOffset().
        Moment.fn.toJSON = function() { return this.format(); }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/locale.config.js